import React, { PureComponent } from 'react';

import './StepBar.scss';

interface OwnProps {
    stepsCount: number;
    currentStep: number;
    title?: string;
}

class StepBar extends PureComponent<OwnProps> {
    render() {
        const { currentStep, stepsCount, title } = this.props;

        return (
            <div className='step-bar'>
                <p className='step-bar__step'><span className='step-bar__step--active'>Step {currentStep}</span> of {stepsCount}</p>
                {title && <h1 className='step-bar__title'>{title}</h1>}
            </div>
        );
    }
}

export default StepBar;